const DEMO = 'demo';
const DEV = 'dev'; // local
const DEV_EXTERNAL = 'devExternal';
const PROD = 'prod';
const SANDBOX = 'sandbox';
const STAGING = 'staging';

const PROTOCOL = window.location.protocol;
const HOST = window.location.host;
const ORIGIN = `${PROTOCOL}//${HOST}`;
const BASE_URL = `${ORIGIN}/`;

const envConfigs = {
  [DEV]: {
    Config: {
      origin: ORIGIN,
      baseRequestUrl: 'https://api.staging.resy.com/',
      assetsBaseUrl: 'https://s3.amazonaws.com/assets.staging.resy.com/',
      apiKey: 'VbWk7s3L4KiK5fzlO7JD3Q5EYolJI7n5',
      automationApiKey: 'AIcdK2rLXG6TYwJseSbmrBAy3RP81ocd',
    },
    ItemsServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://item.staging.resy.com/',
    },
    AnnotationServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://annotation.staging.resy.com/',
    },
    ResyosServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://api.staging.resyos.com/',
    },
    ImageServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://image.staging.resy.com/',
    },
    AutomationMode: document.cookie.includes('automation=true'),
    ResyAmexConfig: {
      baseRequestUrl: 'https://d14rvb61uksiqz.cloudfront.net/',
    },
  },
  [DEV_EXTERNAL]: {
    Config: {
      origin: ORIGIN,
      baseRequestUrl: 'https://api.dev.resy.com/',
      assetsBaseUrl: 'https://s3.amazonaws.com/assets.dev.resy.com/',
      apiKey: 'VbWk7s3L4KiK5fzlO7JD3Q5EYolJI7n5',
      automationApiKey: 'AIcdK2rLXG6TYwJseSbmrBAy3RP81ocd',
    },
    ItemsServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://item.dev.resy.com/',
    },
    AnnotationServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://annotation.dev.resy.com/',
    },
    ResyosServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://api.dev.resyos.com/',
    },
    ImageServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://image.dev.resy.com/',
    },
    AutomationMode: document.cookie.includes('automation = true'),
    ResyAmexConfig: {
      baseRequestUrl: 'https://dw5imgvvi8wn1.cloudfront.net/',
    },
  },
  [DEMO]: {
    Config: {
      origin: ORIGIN,
      baseRequestUrl: 'https://api.demo.resy.com/',
      assetsBaseUrl: 'https://s3.amazonaws.com/assets.demo.resy.com/',
      apiKey: 'VbWk7s3L4KiK5fzlO7JD3Q5EYolJI7n5',
      automationApiKey: 'AIcdK2rLXG6TYwJseSbmrBAy3RP81ocd',
    },
    ItemsServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://item.demo.resy.com/',
    },
    AnnotationServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://annotation.demo.resy.com/',
    },
    ResyosServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://api.demo.resyos.com/',
    },
    ImageServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://image.demo.resy.com/',
    },
    AutomationMode: document.cookie.includes('automation=true'),
    ResyAmexConfig: {
      baseRequestUrl: 'https://d14rvb61uksiqz.cloudfront.net/',
    },
  },
  [PROD]: {
    Config: {
      origin: window.location.host.includes('localhost') || window.location.host.includes('dev.resy.com') ? ORIGIN : 'https://widgets.resy.com',
      baseRequestUrl: 'https://api.resy.com/',
      assetsBaseUrl: 'https://s3.amazonaws.com/resy.com/',
      apiKey: 'VbWk7s3L4KiK5fzlO7JD3Q5EYolJI7n5',
    },
    ItemsServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://item.resy.com/',
    },
    AnnotationServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://annotation.resy.com/',
    },
    ResyosServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://api.resyos.com/',
    },
    ImageServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://image.resy.com/',
    },
    AutomationMode: false,
    ResyAmexConfig: {
      baseRequestUrl: 'https://dw5imgvvi8wn1.cloudfront.net/',
    },
  },
  [SANDBOX]: {
    Config: {
      origin: ORIGIN,
      baseRequestUrl: 'https://api.sandbox.resy.com/',
      assetsBaseUrl: 'https://s3.amazonaws.com/assets.demo.resy.com/',
      apiKey: 'VbWk7s3L4KiK5fzlO7JD3Q5EYolJI7n5',
      automationApiKey: 'AIcdK2rLXG6TYwJseSbmrBAy3RP81ocd',
    },
    ItemsServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://item.sandbox.resy.com/',
    },
    AnnotationServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://annotation.sandbox.resy.com/',
    },
    ResyosServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://api.sandbox.resyos.com/',
    },
    ImageServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://image.sandbox.resy.com/',
    },
    AutomationMode: document.cookie.includes('automation=true'),
    ResyAmexConfig: {
      baseRequestUrl: 'https://d14rvb61uksiqz.cloudfront.net/',
    },
  },
  [STAGING]: {
    Config: {
      origin: ORIGIN,
      baseRequestUrl: 'https://api.staging.resy.com/',
      assetsBaseUrl: 'https://s3.amazonaws.com/assets.staging.resy.com/',
      apiKey: 'VbWk7s3L4KiK5fzlO7JD3Q5EYolJI7n5',
      automationApiKey: 'AIcdK2rLXG6TYwJseSbmrBAy3RP81ocd',
    },
    ItemsServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://item.staging.resy.com/',
    },
    AnnotationServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://annotation.staging.resy.com/',
    },
    ResyosServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://api.staging.resyos.com/',
    },
    ImageServiceConfig: {
      origin: ORIGIN,
      baseUrl: BASE_URL,
      baseRequestUrl: 'https://image.staging.resy.com/',
    },
    AutomationMode: document.cookie.includes('automation=true'),
    ResyAmexConfig: {
      baseRequestUrl: 'https://d14rvb61uksiqz.cloudfront.net/',
    },
  },
};

const getEnvConfigs = () => envConfigs[ENV] || envConfigs[STAGING];

export default getEnvConfigs;
